import { findChildrenOfNodeById } from "./graphmodifier";
import { recreateAuxStructures } from "./graphauxcreator";
export const groupMap = {
    dataOwnerFiles: 1,
    health: 2,
    fitness: 3,
    social: 4,
    shopping: 5,
    financial: 6,
    biometric: 7,
    location: 8,
};
export const groups = Object.keys(groupMap);
const TYPE_DATACATEGORY = "dwin://node/core/dataCategory";
const TYPE_DATAOWNER = "dwin://node/core/dataOwner";
export function calculateGroups(processedGraph) {
    recreateAuxStructures(processedGraph);
    calculateGroupsRecursive(processedGraph, "", 0, processedGraph.nodes[0].id, groupMap);
    recreateAuxStructures(processedGraph);
    calculateNodeGroupUploded(processedGraph, "dof1-2");
    /*for (const node of processedGraph.nodes) {
      if (node.group === undefined && (node.type.endsWith("file") || node.type.endsWith("folder"))) {
        console.log(`calculateGroups check: ${node.id} has no group!`, node);
      }
    }*/
}
function calculateGroupsRecursive(processedGraph, dataCategory, level, rootNodeId, groupMap) {
    const rootNode = processedGraph.aux?.getNodeById(rootNodeId);
    if (rootNode === undefined) {
        return;
    }
    if (rootNode?.type === TYPE_DATACATEGORY) {
        dataCategory = rootNode.value2?.toString() ?? "";
    }
    const dataCategoryNumber = groupMap[dataCategory] ?? 0;
    calculateNodeGroup(rootNode, dataCategoryNumber, level);
    const children = findChildrenOfNodeById(processedGraph, rootNodeId);
    for (const childNode of children) {
        calculateGroupsRecursive(processedGraph, dataCategory, level + 1, childNode.id, groupMap);
    }
}
function calculateNodeGroup(rootNode, dataCategoryNumber, level) {
    if (rootNode.type === TYPE_DATAOWNER) {
        rootNode.group = "user";
    }
    else {
        rootNode.cid = dataCategoryNumber;
        rootNode.level = Math.min(level, 8);
        rootNode.group = rootNode.cid + "" + rootNode.level;
    }
}
function calculateNodeGroupUploded(processedGraph, rootNodeId) {
    const rootNode = processedGraph.aux?.getNodeById(rootNodeId);
    if (rootNode === undefined) {
        return;
    }
    const children = findChildrenOfNodeById(processedGraph, rootNodeId).filter((k) => k.cid === 1);
    rootNode.childCid = 11;
    if (rootNode.group && parseInt(rootNode.group) < 100) {
        rootNode.group = (parseInt(rootNode.group) + 100).toString();
    }
    for (const childNode of children) {
        childNode.childCid = 11;
        if (childNode.group && parseInt(childNode.group) < 100) {
            childNode.group = (parseInt(childNode.group) + 100).toString();
        }
        calculateNodeGroupUploded(processedGraph, childNode.id);
    }
}
